import React from "react";
import { MdClose } from "react-icons/md";
import styles from "./modal.module.scss";

interface SbModalProps {
    show?: boolean;
    children?: any;
    handleClose?: any;
    className?: string;
}

export const SbModal: React.FC<SbModalProps> = ({
    handleClose,
    show,
    children,
    className,
}) => {
    return (
        show && (
            <div className={styles.modal}>
                <section className={[styles.modal_main, className].join(" ")}>
                    {children}
                    <button
                        className={styles.button}
                        type="button"
                        onClick={handleClose}
                    >
                        <MdClose size={24} />
                    </button>
                </section>
            </div>
        )
    );
};
